module.exports = __webpack_public_path__ + "img/组 127@2x(2).9fa43e4a.png";